import type { JSX } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { BackRoom } from "./speakeasy/BackRoom";
import PendingScreen from "./PendingScreen";

// The public front door is the speakeasy. A signed-in + allowlisted friend (`in`) skips to
// /create; a verified-but-not-allowlisted visitor (`pending`) meets the "you're on the list"
// screen; everyone else meets the back room.
export default function Home(): JSX.Element | null {
  const { access, loading } = useAuth();
  if (loading) return null; // no flash before auth resolves
  if (access === "in") return <Navigate to="/create" replace />;
  if (access === "pending") return <PendingScreen />;
  return <BackRoom />;
}
